import React, { useState } from 'react';

import BoxConteudo from '../../../../../../../components/BoxConteudo';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomRow from '../../../../../../../components/CustomRow';
import Input from '../../../../../../../components/InputNew';
import Select from '../../../../../../../components/InputNew/Select';
import Log from '../../../../../../../components/Log/Log';
import WorkspaceFicha from '../../../../../../../components/WorkspaceFicha';
import RegistroEntrega from '../registroEntrega';

const RegistroEntregaForm: React.FC = () => {
  const [formData, setFormData] = useState({
    idParcela: '',
    produtoFarmaceutico: '',
    idProduto: '',
    status: '',
    ufDestino: '',
    dataPrevista: '',
    dataUltEntrega: '',
    qtdPrevista: '',
    qtdEntregue: '',
    observacoes: '',
  });
  const logs = {};

  const handleChange = (name: string, value: any) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <WorkspaceFicha>
      <Log {...logs} entity="TB_ORG_INTER" id={Number(1)} />
      <BoxConteudo boxTitulo="Registro de Entrega">
        {/* Linha 1 */}
        <CustomRow>
          <CustomCol width="33%">
            <Input
              label="ID Plano Entrega"
              type="text"
              name="idParcela"
              value={formData.idParcela}
              onChange={(e) => handleChange('idParcela', e.target.value)}
              readOnly
            />
          </CustomCol>

          <CustomCol width="33%">
            <Input
              label="Produto Farmacêutico"
              type="text"
              name="produtoFarmaceutico"
              value={formData.produtoFarmaceutico}
              onChange={(e) =>
                handleChange('produtoFarmaceutico', e.target.value)
              }
            />
          </CustomCol>

          <CustomCol width="33%">
            <Input
              label="ID do Produto"
              type="text"
              name="idProduto"
              value={formData.idProduto}
              onChange={(e) => handleChange('idProduto', e.target.value)}
            />
          </CustomCol>
        </CustomRow>

        {/* Linha 2 */}
        <CustomRow>
          <CustomCol width="200px">
            <Input
              label="Data Entrega"
              type="date"
              name="dataPrevista"
              value={formData.dataPrevista}
              onChange={(e) => handleChange('dataPrevista', e.target.value)}
            />
          </CustomCol>

          <CustomCol>
            <Input
              label="Qtd Entregue"
              type="number"
              name="qtdPrevista"
              value={formData.qtdPrevista}
              onChange={(e) => handleChange('qtdPrevista', e.target.value)}
            />
          </CustomCol>

          <CustomCol width="150px">
            <Input
              label="% do Previsto"
              type="number"
              name="qtdEntregue"
              value={formData.qtdEntregue}
              onChange={(e) => handleChange('qtdEntregue', e.target.value)}
              readOnly
            />
          </CustomCol>
        </CustomRow>

        {/* Linha 3 */}
        <CustomRow>
          <CustomCol width="100%">
            <Input
              label="Observações"
              name="observacoes"
              type="textarea"
              linhas={4}
              value={formData.observacoes}
              onChange={(e) => handleChange('observacoes', e.target.value)}
            />
          </CustomCol>
        </CustomRow>
      </BoxConteudo>
    </WorkspaceFicha>
  );
};

export default RegistroEntregaForm;
